const HAPPY_HEARTS_SITE_URL = 'https://www.happyhearts.com';

const happyHeartsUrl = (path: string) => `${HAPPY_HEARTS_SITE_URL}${path}`;

const HAPPY_HEARTS_FOOTER_LINKS = [
  { label: 'How it works', href: happyHeartsUrl('/#how') },
  { label: 'For caregivers', href: happyHeartsUrl('/for-caregivers') },
  { label: 'Resources', href: happyHeartsUrl('/blog') },
  { label: 'FAQ', href: happyHeartsUrl('/faq') },
  { label: 'Privacy Notice', href: happyHeartsUrl('/privacy') },
  { label: 'HIPAA Privacy Notice', href: happyHeartsUrl('/hipaa-notice') },
  { label: 'App Privacy Policy', href: happyHeartsUrl('/app-privacy-policy') },
  { label: 'Terms of Service', href: happyHeartsUrl('/terms') },
  { label: 'Accessibility', href: happyHeartsUrl('/accessibility') },
  { label: 'Contact Us', href: happyHeartsUrl('/contact') },
] as const;

export { HAPPY_HEARTS_FOOTER_LINKS, HAPPY_HEARTS_SITE_URL };